import { mapGetters, mapMutations } from "vuex";
import { camelCase } from "lodash";

export default {
    name: "profile-mobile-navigation",
    data() {
        return {
            label: "",
            isNavigationRoute: false,
            isMobile: false,
        };
    },
    watch: {
        $route() {
            this.changeSelectLabel();
        },
    },
    computed: {
        ...mapGetters({
            prevRoute: "user/prevRoute",
            profileRoutes: "user/profileRoutes",
        }),
    },
    created() {
        this.changeSelectLabel();
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
        ...mapMutations({
            changeMobileMenu: "system/CHANGE_MOBILE_MENU",
            changeShowPersonalMenu: "user/MOBILE_CHANGE_SHOW_MENU",
            removeProfileRoute: "user/REMOVE_PROFILE_ROUTE",
        }),
        changeSelectLabel() {
            if (this.$route.name === "profile-user") {
                this.isNavigationRoute = true;
            } else {
                this.isNavigationRoute = false;
                this.changeShowPersonalMenu(false);
            }

            if (this.$route.name === "profile-subscription") {
                this.label = this.$t("profilePaymentsHistory");
            } else {
                this.label = camelCase(this.$route.name);
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 950;
        },
        changeAction(val) {
            if (val) {
                this.changeShowPersonalMenu(true);

                if (window.innerWidth >= 900 && this.profileRoutes.length > 0) {
                    const previousRoute =
                        this.profileRoutes[this.profileRoutes.length - 1];
                    this.$router.push(previousRoute);
                    this.removeProfileRoute();
                } else {
                    if (this.isMobile) {
                        this.$router.go(-1);
                    } else {
                        this.$router.push(this.prevRoute);
                    }
                }
            } else {
                this.changeMobileMenu(true);
            }
        },
        closeProfileNav() {
            if (this.isMobile) {
                this.changeShowPersonalMenu(true);
            }

            this.$router.push(this.prevRoute);

            // if (this.$route.path.includes("/profile/")) {
            //     if (this.isMobile) {
            //         this.$router.push({ name: "profile-user" });
            //         this.changeShowPersonalMenu(true);
            //     } else {
            //         this.$router.push({ name: "courses" });
            //     }
            // } else {
            //     if (this.isMobile && this.$route.path === "/uk/profile") {
            //         this.$router.push({ name: "courses" });
            //     } else {
            //         this.$router.go(-1);
            //     }
            // }
        },
    },
};
